import React from 'react'
import { Image } from 'react-bootstrap'

import Img from 'components/ui/Img'
import logo from '../../../assets/defaultCourse.png'
import logoMd from '../../../assets/defaultCourseDetail.png'
import { ImgProps } from '../Img/types'
import styles from './ImageFull.module.scss'

export enum ImageSizes {
  ExtraSmall = 'Xs',
  Small = 'Sm',
  Medium = 'Md',
  Large = 'Lg',
}

interface ITagProps {
  src: string | undefined
  sizes?: ImageSizes
  className?: string
}

const heightSizes = {
  [ImageSizes.ExtraSmall]: 100,
  [ImageSizes.Small]: 200,
  [ImageSizes.Medium]: 550,
  [ImageSizes.Large]: 700,
}

const ImageFull: React.FC<ITagProps & ImgProps> = ({
  src,
  sizes = ImageSizes.Medium,
  className = '',
  ...props
}) => {
  return (
    <Img
      component={Image}
      className={`${styles.image} ${className} ${styles[`${sizes}`]}`}
      src={src || (sizes === ImageSizes.Medium ? logoMd : logo)}
      onError={(e) => {
        e.currentTarget.src = sizes === ImageSizes.Medium ? logoMd : logo
      }}
      imageHandlerProps={{
        height: heightSizes[sizes],
      }}
      {...props}
    />
  )
}

export default ImageFull
